import React, { useContext } from 'react';
import { bool, func } from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import tracker from '../../../service/tracker';
import { EVENTS_MAPPING } from '../../../utils/constants';
import { CarouselContext } from '.';

const SkipButton = ({ showSkipButton, setShowBackButton }) => {
    const { setStepIndex, stepIndex, filterId, stepNum } = useContext(CarouselContext);

    if (!showSkipButton) {
        return null;
    }

    const clickedSkip = () => {
        setStepIndex(stepIndex + 1);
        setShowBackButton(true);
        tracker.trackTileFilter(EVENTS_MAPPING.FILTERS_SKIP, filterId, stepNum);
    };

    return (
        <div className="skip-btn">
            <div className="skip-text" onClick={clickedSkip}>
                <I18n k={'search_perseus.filter_tiles.skip'}/>
            </div>
        </div>
    );
};

SkipButton.propTypes = {
    showSkipButton: bool,
    setShowBackButton: func
};

export default SkipButton;
